import { Formik } from "formik";
import { convertNumberPrice } from "../../../utils/FormatUtils";
import TextField from "../../../component/TextField";

const getColumnThongTinVienPhi = (
  isPhieuThu: boolean,
  handleChangeValueTable: (
    row: any,
    value: number,
    index: any,
    name: any
  ) => void,
  dsThongTinDv?: any,
  setInputFocused = (id: any) => {},
  inputFocused?: any,
  arraySelect?: any,
  setRowEdit = (row: any) => {}
) => {
  return [
    {
      title: "Dịch vụ",
      field: "termSvcNameClone",
      className: "spaces w-25",
    },
    {
      title: "ĐVT",
      field: "svcUnit",
      className: "spaces width-20px",
      render: (rowData: any) => {
        return (
          <span className={`${rowData?.isCancel ? "text-danger" : ""}`}>
            {rowData?.svcUnit}
          </span>
        );
      },
    },
    {
      title: "Đối tượng",
      field: "termObjectTypeName",
      className: "spaces width-35px text-center",
      render: (rowData: any) => {
        return (
          <span className={`${rowData?.isCancel ? "text-danger" : ""}`}>
            {rowData?.termObjectTypeName}
          </span>
        );
      },
    },
    {
      title: "SL",
      field: "svcQuantity",
      className: "spaces width-20px text-center",
      render: (rowData: any) => {
        return (
          <span className={`${rowData?.isCancel ? "text-danger" : ""}`}>
            {rowData?.svcQuantity}
          </span>
        );
      },
    },
    {
      title: "Đơn giá",
      field: "svcPriceClone",
      className: "spaces width-25px text-end",
      render: (rowData: any) => {
        return (
          <span className={`${rowData?.isCancel ? "text-danger" : ""}`}>
            {rowData?.svcPriceClone !== undefined
              ? convertNumberPrice(rowData?.svcPriceClone)
              : ""}
          </span>
        );
      },
    },
    {
      title: "% TT",
      field: "svcTotalPercent",
      className: "spaces width-20px text-center",
      render: (rowData: any, index: any, stt: number) => {
        return (<span className={`${rowData?.isCancel ? "text-danger" : ""}`}>
          {rowData?.svcTotalPercent
            ? rowData?.svcTotalPercent
            : ""}
        </span>)
      },
    },
    {
      title: "Thành tiền",
      field: "svcTotalClone",
      className: "spaces width-35px text-end",
      render: (rowData: any) => {
        return (
          <span className={`${rowData?.isCancel ? "text-danger" : ""}`}>
            {rowData?.svcTotalClone !== undefined || rowData?.svcTotal !== undefined 
              ? convertNumberPrice(rowData?.svcTotalClone || rowData?.svcTotal) 
              : ""}
          </span>
        );
      },
    },
    {
      title: "",
      field: "paymentPtPercent",
      className: "spaces width-20px text-center",
      render: (rowData: any, index: any, stt: number) => {
        return (
          <Formik initialValues={{}} onSubmit={() => {}}>
            {isPhieuThu &&
            !rowData?.isPaid &&
            rowData?.isPaid !== undefined &&
            rowData?.svcPriceClone !== 0 &&
            arraySelect?.includes(rowData?.id) ? (
              <TextField
                label=""
                className={`input input-col-vp text-end ${"paymentPtPercentClone-" +
                dsThongTinDv[index[0]].orderData[index[1]]?.id}`}
                name="paymentPtPercentClone"
                type="number"
                placeholder="%"
                value={
                  rowData?.paymentPtPercentClone || 0
                }
                onChange={(e: any) => {
                  handleChangeValueTable(
                    rowData,
                    Number(e.target.value),
                    index,
                    "paymentPtPercentClone"
                  );
                }}
                onFocus={(e: any) => {
                  setInputFocused(
                    "paymentPtPercentClone-" +
                      dsThongTinDv[index[0]].orderData[index[1]]?.id
                  );
                  setRowEdit(rowData)
                }}
                autoFocus={
                  "paymentPtPercentClone-" + rowData?.id === inputFocused
                }
                onWheel={(e: any) => e?.currentTarget?.blur()}
              />
            ) : (
              <span className="text-center">{rowData?.paymentPtPercentClone || ""}</span>
            )}
          </Formik>
        );
      },
    },
    {
      title: "MG",
      field: "discountClone",
      className: "spaces width-30px text-end",
      render: (rowData: any, index: any, stt: number) => {
        return (
          <span className={`${rowData?.isCancel ? "text-danger" : ""}`}>
            {rowData?.discountClone || rowData?.discount
              ? convertNumberPrice(rowData?.discountClone || rowData?.discount)
              : ""}
          </span>
        );
      },
    },
    { title: "% bh", field: "paymentInsPercent", className: "spaces width-20px text-center", render: (rowData: any, index: any, stt: number) => {
      return (
        <span className={`${rowData?.isCancel ? "text-danger" : ""}`}>
          {rowData?.paymentInsPercent
            ? convertNumberPrice(rowData?.paymentInsPercent)
            : ""}
        </span>
      );
    },},
    {
      title: "Thành tiền BHYT",
      field: "totalIns",
      className: "spaces width-35px text-end",
      render: (rowData: any, index: any, stt: number) => {
        return (
          <span className={`${rowData?.isCancel ? "text-danger" : ""}`}>
            {rowData?.totalIns
              ? convertNumberPrice(rowData?.totalIns)
              : ""}
          </span>
        )
      },
    },
    { title: "Quỹ BHYT", field: "paymentInsTotal", className: "spaces width-28px text-end", render: (rowData: any, index: any, stt: number) => {
      return (
        <span className={`${rowData?.isCancel ? "text-danger" : ""}`}>
          {rowData?.paymentInsTotal
            ? convertNumberPrice(rowData?.paymentInsTotal)
            : ""}
        </span>
      );
    }, },
    { title: "#bncct", field: "bncct", className: "spaces width-35px text-end", render: (rowData: any, index: any, stt: number) => {
      return (
        <span className={`${rowData?.isCancel ? "text-danger" : ""}`}>
          {rowData?.paymentInsPtTotal
            ? convertNumberPrice(rowData?.paymentInsPtTotal)
            : ""}
        </span>
      );
    } },
    {
			title: '#BNTT',
			field: 'bntt',
			className: 'spaces width-30px text-end',
			render: (rowData: any) => {
				return (
					<span className={`${rowData?.isCancel ? 'text-danger' : ''}`}>
						{rowData?.paymentPt ? convertNumberPrice(rowData?.paymentPt) : ''}
					</span>
				);
			},
		},
    {
      title: "BN trả",
      field: "svcPtTotal",
      className: "spaces width-25px text-end",
      render: (rowData: any) => {
        return (
          <span className={`${rowData?.isCancel ? "text-danger" : ""}`}>
            {rowData?.svcPtTotalClone !== undefined
              ? convertNumberPrice(rowData?.svcPtTotalClone)
              : ""}
          </span>
        );
      },
    },
    { 
      title: "#Đã thu BNCCT", 
      field: "daThuCCT", 
      className: "spaces width-35px text-end",
      render: (rowData: any) => {
				return (
					<span className={`${rowData?.isCancel ? 'text-danger' : ''}`}>
						{rowData?.paymentPtReceiptIns ? convertNumberPrice(rowData?.paymentPtReceiptIns) : ''}
					</span>
				);
			},
    },
    {
      title: "#Đã thu BNTT",
      field: "daThubntt",
      className: "spaces width-35px text-end",
      render: (rowData: any) => {
				return (
					<span className={`${rowData?.isCancel ? 'text-danger' : ''}`}>
						{rowData?.paymentPtReceipt ? convertNumberPrice(rowData?.paymentPtReceipt) : ''}
					</span>
				);
			},
    },
    {
      title: "Đã thu",
      field: "svcCollected",
      className: "spaces width-35px text-end",
      render: (rowData: any) => {
        return (
          <span className={`${rowData?.isCancel ? "text-danger" : ""}`}>
            {rowData?.svcCollected
              ? convertNumberPrice(rowData?.svcCollected)
              : ""}
          </span>
        );
      },
    },
   
  ];
};

export { getColumnThongTinVienPhi };

